(function($){

	$('a.open-popup-link, .open-popup-link a').magnificPopup({
		type: 'inline',
		// modal: true,
		closeOnBgClick: true,
		closeOnContentClick: false,
		showCloseBtn: true,
		closeBtnInside: true,
		enableEscapeKey: false,
		callbacks: {
			open: function() {
				//console.log('Modal Opened')
			},
			close: function() {
				//console.log('Modal Closed')
			}
		}
	});



	$('.boarding-pass-featured-link, .more-programs a').magnificPopup({
		type: 'inline',
		// modal: true,
		closeOnBgClick: true,
		closeOnContentClick: false,
		showCloseBtn: true,
		closeBtnInside: true,
		enableEscapeKey: false,
		callbacks: {
			open: function() {
				//console.log('Modal Opened')
			},
			close: function() {
				//console.log('Modal Closed')
			}
		}
	});



	// $('.boarding-pass-featured-image').click(function() {
	// 	$.magnificPopup.open({
	// 		items: {src: $(this).attr('href')},
	// 		type: 'inline'
	// 	});
	// });

})(jQuery);



